<template>
  <div
    id="events"
    class="reader-wrapper lazy-container"
    :class="{ 'article-open': currentEvent }"
  >
    <div class="reader-left relative col col-12 md-col-6 lg-col-5">
      <h2 class="caps py1 px2 mb0 pb0 sticky bg-light border-bottom z1 fs-s">
        <div class="clearfix">
          <div class="col col-6">
            <span class="red">Current & Upcoming</span>
          </div>
          <div class="col col-6 right-align">
            Today is <span v-text="today"></span>
          </div>
        </div>
      </h2>
      <ul class="list-reset m0" v-if="currentEvents.length">
        <li
          v-for="event in currentEvents"
          @click.stop="updateCurrentEvent(event)"
          :ref="`feed-item-${event.id}`"
          :key="`feed-item-${event.id}`"
          class="reader-block border-bottom p2 pb3 pointer item"
        >
          <router-link
            :to="{ name: 'Events', params: { slug: event.slug } }"
            replace
          >
            <div class="clearfix mxn2">
              <div class="col col-3 px2 tabular">
                {{ eventDates(event) }}<br />
                <div class="mt1 subdued fs-s">
                  {{ exhibitionDistance(event, "") }}
                </div>
              </div>
              <div class="col col-9 px2">
                <h2 class="caps m0">{{ event.title }}</h2>
                <span v-html="preventWidows(event.venue)" />
                <div class="subdued caps fs-s mt1" v-if="event.type">
                  {{ event.type[0].name }}
                </div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
      <div v-else class="px2 py3">
        No current events to display.<br />
        <br />
        <router-link class="border-bottom-red" :to="{ name: 'Exhibitions' }"
          >Visit our exhibitions page</router-link
        >
        to see current and upcoming exhibitions.
      </div>
      <h2
        class="caps py1 px2 mb0 pb0 sticky bg-light border-top border-bottom z1 fs-s"
      >
        <span class="red">Past Events</span>
      </h2>
      <ul class="list-reset m0">
        <li
          v-for="event in otherEvents"
          @click="updateCurrentEvent(event)"
          :ref="`feed-item-${event.id}`"
          :key="`feed-item-${event.id}`"
          class="reader-block item border-bottom p2 pb3 pointer"
        >
          <router-link
            :to="{ name: 'Events', params: { slug: event.slug } }"
            replace
          >
            <div class="clearfix mxn2">
              <div class="col col-3 px2 tabular">
                {{ eventDates(event) }}
              </div>
              <div class="col col-7 px2">
                <h2 class="caps m0">{{ event.title }}</h2>
                <span>{{ event.venue }}</span>
                <div class="subdued caps fs-s mt1" v-if="event.type">
                  {{ event.type[0].name }}
                </div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>

    <div
      v-if="currentEvent"
      class="reader-right col col-12 md-col-6 lg-col-7 relative xs-hide"
    >
      <!-- TODO: Prev/Next Events -->
      <!-- <div class="sticky bg-light item border-bottom flex justify-content col-12 caps fs-s">
        <span class="noselect p1 flex-auto hover-red pointer center border-right border-black" @click="previousArticle()">Previous</span>
        <span class="noselect p1 flex-auto hover-red pointer center" @click="nextArticle()">Next</span>
      </div> -->
      <div class="p2 max-reader-width mx-auto mt3">
        <div class="subdued center mb2 caps fs-s" v-if="currentEvent.type">
          {{ currentEvent.type[0].name }}
        </div>
        <h2 class="caps center" v-html="currentTitle"></h2>
        <h3 class="caps center tabular" v-html="currentEventDate"></h3>
        <a
          class="hover-red"
          v-if="currentMap"
          :href="currentMap"
          target="_blank"
        >
          <h4 class="caps center" v-html="preventWidows(currentVenue)"></h4>
        </a>
        <h4
          v-else
          class="caps center"
          v-html="preventWidows(currentVenue)"
        ></h4>
        <div class="mt3 sans fs-reader" v-html="currentContent"></div>
      </div>
    </div>

    <div
      v-if="currentEvent"
      class="reader-mobile col col-12 md-col-6 lg-col-7 relative md-hide lg-hide"
    >
      <div
        class="z4 sticky bg-light item border-bottom flex justify-content col-12 caps fs-s"
      >
        <span
          class="noselect p1 flex-auto hover-red pointer center border-right border-black"
          @click="closeEvent()"
          >Close</span
        >
        <!-- TODO: Prev/Next Events -->
        <!-- <span class="noselect p1 flex-auto hover-red pointer center border-right border-black" @click="previousEvent()">Previous Event</span>
        <span class="noselect p1 flex-auto hover-red pointer center" @click="nextEvent()">Next Event</span> -->
      </div>
      <div class="p2 max-reader-width mx-auto mt1">
        <div class="subdued center mb2 caps fs-s" v-if="currentEvent.type">
          {{ currentEvent.type[0].name }}
        </div>
        <h2 class="caps center" v-html="currentTitle"></h2>
        <h3 class="caps center tabular" v-html="currentEventDate"></h3>
        <a v-if="currentMap" :href="currentMap" target="_blank">
          <h4 class="caps center" v-html="preventWidows(currentVenue)"></h4>
        </a>
        <h4
          v-else
          class="caps center"
          v-html="preventWidows(currentVenue)"
        ></h4>
        <div class="mt3 sans fs-reader" v-html="currentContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
  formatDate,
  getPreviewVideoFile,
  getPreviewImageFile,
  getPreviewImageStyle,
  eventDates,
  exhibitionDistance,
} from "@/utils";
import CloseButton from "@/components/CloseButton";
import SubMenu from "@/components/SubMenu";
import CardBlock from "@/components/CardBlock";
import Current from "@/components/Current";
import VueScrollTo from "vue-scrollto";

export default {
  name: "Events",

  data() {
    return {
      currentEvent: false,
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img",
      }),
    };
  },

  metaInfo() {
    return {
      title: this.currentEvent.title,
      meta: [
        { name: "og:title", content: this.getMeta.title },
        { name: "twitter:title", content: this.getMeta.title },
        { name: "og:image", content: "/fa-share-lg.png" },
        { name: "twitter:image", content: "/fa-share-lg.png" },
        {
          name: "og:url",
          content: `${window.location.origin}/${this.$route.fullPath}`,
        },
        { name: "og:type", content: "website" },
        { name: "og:description", content: this.getMeta.description },
        { name: "twitter:description", content: this.getMeta.description },
      ],
    };
  },

  components: {
    CardBlock,
    CloseButton,
    Current,
    SubMenu,
  },

  mounted() {
    // TODO: Custom media var for breakpoints
    if (
      !window.matchMedia("(max-width: 52em)").matches &&
      !this.$route.params.slug
    ) {
      this.$router.replace({
        name: "Events",
        params: { slug: this.currentEvents[0].slug },
      });
    } else {
      this.updateEventFromSlug();
    }
  },

  watch: {
    $route() {
      this.updateEventFromSlug();
      this.lazyContainer.update();
    },
    currentEvent() {
      this.$nextTick(function () {
        this.lazyContainer.update();
      });
    },
  },

  computed: {
    ...mapState(["events"]),
    ...mapGetters(["currentEvents", "otherEvents"]),
    currentContent() {
      return this.currentEvent.content;
    },
    currentMap() {
      if (this.currentEvent.location_map.address) {
        return `https://www.google.com/maps/search/?api=1&query=${this.currentEvent.location_map.address}`;
      } else {
        return false;
      }
    },
    currentTitle() {
      return this.preventWidows(this.currentEvent.title);
    },
    currentEventDate() {
      if (this.currentEvent) {
        return this.eventDates(this.currentEvent);
      } else {
        return false;
      }
    },
    currentVenue() {
      return this.currentEvent.venue;
    },
    today() {
      return this.formatDate(Date(), "D MMMM");
    },
  },

  methods: {
    formatDate,
    getPreviewVideoFile,
    getPreviewImageFile,
    getPreviewImageStyle,
    eventDates,
    exhibitionDistance,
    closeEvent() {
      if (window.from.name === "Exhibitions") {
        this.$router.go(-1);
      } else {
        this.currentEvent = false;
      }
      // this.$router.replace({ name: "Events" })
    },
    getMeta() {
      if (this.currentEvent) {
        return {
          title: this.currentTitle,
          description: `Forensic Architecture → ${this.currentVenue} → ${this.currentEventDate}`,
        };
      } else {
        return {
          title: "Events",
        };
      }
    },
    scrollSideBar() {
      let el = this.$refs[`feed-item-${this.currentEvent.id}`][0];
      console.log(el);
      VueScrollTo.scrollTo(el, {
        container: ".reader-left",
        offset: -32,
        duration: 250,
      });
    },
    updateCurrentEvent(event) {
      this.$router.replace({ name: "Events", params: { slug: event.slug } });
    },
    updateEventFromSlug() {
      if (this.$route.params.slug !== undefined) {
        this.currentEvent = this.events.find((x) => {
          return x.slug === this.$route.params.slug;
        });
        this.scrollSideBar();
      }
    },
  },
};
</script>

<style lang="css" scoped>
.router-link-exact-active {
  h3 {
    color: var(--red);
  }
}

>>> img.cursor-zoom-in {
  cursor: auto;
}

li:last-child {
  border: none;
}
</style>
